(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.addEventListener('variant:update', event => {
    if (reduced()) return;
    const section = event.target.closest('.shopify-section');
    const oldGallery = section?.querySelector('media-gallery[data-trial-portdock]');
    const oldImage = oldGallery?.querySelector('slideshow-slide:first-child .product-media__image');
    if (!oldImage?.complete || !oldImage.naturalWidth) return;
    const previousSrc = oldImage.currentSrc;
    requestAnimationFrame(async () => {
      const gallery = section.querySelector('media-gallery[data-trial-portdock]');
      const image = gallery?.querySelector('slideshow-slide:first-child .product-media__image');
      if (!image || gallery === oldGallery || previousSrc === image.currentSrc) return;
      const box = image.getBoundingClientRect();
      const parent = gallery.getBoundingClientRect();
      const ghost = new Image();
      ghost.src = previousSrc;
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.className = 'th-trial-media-ghost';
      gallery.style.position = 'relative';
      Object.assign(ghost.style, {left:`${box.left-parent.left}px`,top:`${box.top-parent.top}px`,width:`${box.width}px`,height:`${box.height}px`});
      gallery.append(ghost);
      try { await image.decode(); } catch {}
      if (!gallery.isConnected || reduced()) { ghost.remove(); return; }
      const animation = ghost.animate([{opacity:1},{opacity:0}], {duration:180,easing:'ease-out',fill:'forwards'});
      animation.finished.catch(() => {}).finally(() => ghost.remove());
    });
  }, true);
  window.addEventListener('popstate', () => {
    if (document.querySelector('media-gallery[data-trial-portdock]') || location.pathname.includes('/products/p70-cordless-air-duster')) location.reload();
  });
})();

